import React, { useEffect, useState } from "react"
import { Link } from "gatsby"
import IconCircle from "../icon-circle"
import ShoppingCart from "../../svgs/shopping-cart.svg"
import Bars from "../../svgs/bars-solid.svg"
import { useAuth0 } from "@auth0/auth0-react"
import UseAuthHelper from "../../hooks/useAuthHelper"
import WSFlywheel from "../../svgs/components/ws-flywheel"
import CartInventoryCount from "../cart/cart-inventory-count"
import Arrow from "../../svgs/arrow-up-right-solid.svg"
import Carousel from "react-bootstrap/Carousel"

const Header = props => {
  const { user, loginWithRedirect, logout } = useAuth0()
  let [meta_data, setMetaData] = useState({})

  const readMetaData = result => {
    setMetaData(result)
  }

  UseAuthHelper(readMetaData)

  useEffect(() => {
    if (!user) return
  }, [meta_data])

  return (
    <header className="d-flex flex-column" id="page-header">
      <div
        className={`bg-midnight-blue`}
        style={{ paddingTop: "1rem", paddingBottom: "1rem" }}
      >
        <Carousel
          controls={false}
          indicators={false}
          fade={true}
          className="container d-flex"
          id="alert-banner"
        >
          <Carousel.Item>
            <Link
              to={"https://www.flywheeldigital.com/"}
              className="text-nowrap d-flex"
            >
              <p
                className={`text-white m-auto`}
                style={{ textDecoration: "underline" }}
              >
                WhyteSpyder is now Flywheel Digital{" "}
                <Arrow className="ms-2" style={{ height: "14px" }} />
              </p>
            </Link>
          </Carousel.Item>
          <Carousel.Item>
            <div className="d-flex">
              <p className={`text-white m-auto`}>
                We provide Walmart and omnichannel solutions for the world’s
                largest brands as Flywheel.
              </p>
            </div>
          </Carousel.Item>
        </Carousel>
      </div>

      <div className="container d-flex d-print-none" id="header-content">
        <Link to="/">
          <WSFlywheel id="sku-ninja-svg" />
        </Link>


        <div id="account-container">
          <Link to="/cart" className="position-relative">
            <CartInventoryCount />
            <IconCircle
              size={"40px"}
              color={"#00aeef"}
              icon={<ShoppingCart />}
            />
          </Link>
        </div>

      </div>
    </header>
  )
}

export default Header
